import axios from '@lib/axios';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

export interface InputAgendaTopic {
  [key: string]: boolean;
}

export interface Data {
  topics: InputAgendaTopic;
  highlightSummary: string;
	onlySave?: boolean;
}

interface Props {
  agendaId: string;
	onSuccess?: (onlySave: boolean) => void;
  onError?: (res: AxiosError) => void;
}

export const useSetTopicsToAgenda = ({
  agendaId,
	onSuccess,
  onError
}: Props) => {
	const queryClient = useQueryClient();
  const {
		mutate: onSetTopicsToAgenda,
		variables,
		...rest
	} = useMutation({
		mutationFn: async ({ topics, onlySave, ...data }: Data) => {
      const agendaTopics = Object.entries(topics).map(([topicId, highlighted]) => ({ topicId, highlighted }));
      await axios.post(`/agendas/${agendaId}/topics`, { ...data, agendaTopics });
    },
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['agendaNotes'] });
			if (onSuccess)
				onSuccess(!!variables?.onlySave);
		},
    onError
	});

	return { onSetTopicsToAgenda, variables, ...rest };
};
